import React from 'react';
import Sidebar from "./Sidebar";
import SEO from "../components/seo";

const BrazzingRoad = () => {

  //   if (!project) return <div className="project-right">Select a project to see details.</div>;

  return (
    <>
      <SEO pageKey="brazzingRod" />
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n    .quote-banner {\n     background: linear-gradient(to left, #000814, #0b1234, #2d3f7a);\n      color: white;\n      padding: 20px 30px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n     /*flex-wrap: wrap;*/\n    }\n    .quote-banner h5 {\n      margin: 0;\n      font-weight: 700;\n      font-style: italic;\n    }\n    .quote-banner .btn {\n      font-weight: 600;\n      text-transform: uppercase;\n      margin: 5px;\n    }\n\n    .composition-card {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  }\n\n  .composition-header {\n    background: #0E47A1; /* dark navy (like your image) */\n    color: #fff;\n    font-weight: 700;\n    padding: 12px 20px;\n    font-size: 1rem;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ccc !important;\n    vertical-align: middle;\n  }\n\n  .table th {\n    width: 10%;\n    font-weight: 600;\n  }\n\n    .table-container {\n      background: #fff;\n      color: #000;\n      border-radius: 6px;\n      overflow: hidden;\n    }\n\n    .table {\n      margin: 0;\n      border-collapse: separate;\n      border-spacing: 0;\n      border-radius: 10px;\n      overflow: hidden;\n    }\n   .tbl_thred th{\n      background-color: #0E47A1;\n      color: #fff;\n    }\n    \n  "
        }}
      />
      <main>
        {/* breadcrumb area start */}
        <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
          <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
            <img
              src="/static/img/shape/breadcrumn-shape.webp"
              alt=""
            />
          </div>
          <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
            <img
              src="/static/img/shape/ca-line-shape.WebP"
              alt=""
            />
          </div>
          <div className="container">
            <div className="ca-breadcrumb-content text-center">
              <h2 className="ca-breadcrumb-title fnw-600">Brazzing Road</h2>
              <div className="it-breadcum-link">
                <a href="/">Home</a>
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
                <a href="/products">Products</a>
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
                <a className="active" href="#">
                 Brazzing Road
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* breadcrumb area end */}
        {/* project left */}
        <div className="ca-service-lft-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mb-30">
                <div className="ca-project-content-area">
                  <div className="ca-pro-thumb-content">
                    <h2 className="ca-project-thumb-title theme-black-3 fnw-600 ca-text-cap">
                      Brazzing Road
                    </h2>
                    <p className="pt-16 pb-40">
                      We manufacture and supply high-quality Brazing Rods designed for strong, leak-proof joints in copper, brass, steel, and other metal piping systems. These rods ensure superior bonding strength, smooth capillary flow, and long-lasting performance — ideal for HVAC, refrigeration, plumbing, and industrial fabrication applications.
                    </p>
                    <div className="ca-servic-thumb br-7">
                      <img
                        className="w-100"
                        src="/static/img/portfolio/Product_Road.webp"
                        alt=""
                      />
                    </div>
                    <br />
                    <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                      Manufacturing Excellence and Applications
                    </h3>
                    <p className="pt-16">
                      At Karmyogi Enterprises, our Brazing Rods are produced from high-purity copper and phosphorus alloys, formulated to deliver excellent wetting and flow properties. Each rod is manufactured with precise composition control and consistent quality to ensure reliable performance in every joint.
                    </p>
                    
                    <div className="ca-about-item3 cream-bg-3 p-relative">
                      <p>
                        Our brazing rods eliminate the need for flux when joining copper-to-copper and are compatible with most ferrous and non-ferrous metals. They are widely used in air-conditioning, refrigeration lines, heat exchangers, and plumbing systems for creating durable and corrosion-resistant connections.
                      </p>
                    </div>
                    <div className="ca-ab-item-check ca-ab-item-check-2 caborder-top">
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            High Bond Strength & Leak-Proof Joints
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Excellent Flow & Wetting Characteristics
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Fluxless Brazing for Copper-to-Copper Joints
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Superior Corrosion & Temperature Resistance
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                            Easy to Use with Oxy-Acetylene Flame or Torch
                          </h4>
                        </div>
                      </div>
                      {/* single-item */}
                      <div className="ca-ab-sngle-item">
                        <div className="ca-ab-sngle-item-ic">
                          <span>
                            <i className="fa-solid fa-check" />
                          </span>
                        </div>
                        <div className="ca-ab-sngle-item-content">
                          <h4 className="ca-item-ch-title ca-text-cap">
                           Ideal for HVAC, Refrigeration & Plumbing Applications
                          </h4>
                        </div>
                      </div>
                    </div>
                    
                    <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                      Material Composition and Performance
                    </h3>
                    <p className="pt-16">
                      Our brazing rods are typically made from Copper-Phosphorus (CuP) or Silver-Copper-Phosphorus (AgCuP) alloys. These compositions ensure smooth flow and excellent joint strength while minimizing oxidation and porosity. The phosphorus acts as a fluxing agent, enhancing bonding without requiring external flux when brazing copper components.
                    </p>
                  </div>
                </div>
                {/* Chemical Composition Table */}
                   <div className="container my-4">
                    {/* <div className="container table-container mt-4">
                          <div className="composition-header">
                              Chemical Composition (Typical Grades)
                            </div>
                          <table className="table table-bordered text-center align-middle table-bordered_tbl">
                            <thead className="tbl_thred">
                              <tr>
                                <th>Alloy Type</th>
                                <th>Cu (%)</th>
                                <th>P (%)</th>
                                <th>Ag (%)</th>
                                <th>Melting Range (°C)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>CuP 182</td>
                                <td>92.8</td>
                                <td>7.2</td>
                                <td>—</td>
                                <td>710 – 890</td>
                              </tr>
                              <tr>
                                <td>CuP 179</td>
                                <td>94.0</td>
                                <td>6.0</td>
                                <td>—</td>
                                <td>710 – 890</td>
                              </tr>
                              <tr>
                                  <td>AgCuP 2</td>
                                <td>92.8</td>
                                <td>6.2</td>
                                <td>1.0</td>
                                <td>645 – 825</td>
                              </tr>
                              <tr>
                                <td>AgCuP 3</td>
                                <td>91.5</td>
                                <td>6.0</td>
                                <td>2.5</td>
                                <td>645 – 815</td>
                              </tr>
                              <tr>
                                <td>AgCuP 5</td>
                                <td>89.0</td>
                                <td>6.0</td>
                                <td>5.0</td>
                                <td>645 – 815</td>
                              </tr>
                            </tbody>
                          </table>
                        </div> */}
              
            </div>
           <div className="composition-card">
                <div className="composition-header">
                 Available Specifications
                </div>
                <table className="table table-bordered mb-0">
                  <thead className="tbl_thred">
                  <tr>
                    <th scope="row">Parameter</th>
                    <th>Range / Options</th>
                  </tr>
                </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Diameter</th>
                      <td>1.6 mm – 5.0 mm</td>
                    </tr>
                    <tr>
                      <th scope="row">Length</th>
                      <td>500 mm – 1000 mm</td>
                    </tr>
                    <tr>
                      <th scope="row">Form</th>
                      <td>Straight Rods / Coils</td>
                    </tr>
                    <tr>
                      <th scope="row">Packaging</th>
                      <td>Bundles / Boxes / Custom Packs</td>
                    </tr>
                    <tr>
                      <th scope="row">Alloy Type</th>
                      <td>CuP / AgCuP / CuPAg Custom Grades</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>

           {/* Sidebar */}
          <Sidebar />
              
            </div>
          </div>
        </div>
        <div className="ca-more-section pb-70">
          <div className="container">
            {/* <h2 class="ca-more-title theme-black-3 fnw-600 text-center mb-60">More Projects</h2>
   <div class="row">
      <div class="col-lg-4 col-md-6"> */}
            {/* single-portfolio-item */}
            {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/static/img/portfolio/portfolio-sm-1.4.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/static/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
            {/* single-portfolio-item */}
            {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/static/img/portfolio/portfolio-sm-1.5.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/static/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
            {/* single-portfolio-item */}
            {/*  <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/static/img/portfolio/portfolio-sm-1.6.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/static/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div> */}
            {/* </div>
   </div>
 */}
          </div>
        </div>
      </main>
    </>

  );
};

export default BrazzingRoad;
